// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"66ed1e68","786":"7672b216"}[chunkId] + ".chunk.js";
};